import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isNumber } from '@pct-ts/typeguard';

@Pipe({
  name: 'dateOrTimestampToLocaleString',
})
export class DateOrTimestampToLocaleStringPipe implements PipeTransform {
  transform(value: number | Date): unknown {
    if (isNumber(value)) {
      return new Date(value).toLocaleString();
    }
    return value.toLocaleString();
  }
}
